import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CoacheeProfileNotesController } from 'presentation/page/profile/coachee-profile/coachee-profile-notes/coachee-profile-notes.controller';
import { IUser } from 'user/user';

@Component({
	selector: 'spr-coachee-profile-notes-filter',
	templateUrl: './coachee-profile-notes-filter.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class:
			'flex md:items-center p-3 md:space-x-3 even:bg-grey-alabaster md:flex-row flex-col md:space-y-0 space-y-3',
	},
})
export class CoacheeProfileNotesFilterComponent {
	constructor(public controller: CoacheeProfileNotesController) {}

	public onAddClick(coachee: IUser) {
		this.controller.addUserNote(coachee.id);
	}

	public onDateSortClick() {
		this.controller.toggleDateSort();
	}
}
